@if (data.length) {
    <dx-chart [dataSource]="data"
              [pathModified]="true"
              title="Cultural Indexes"
              [customizePoint]="culturalIndexUiService.customiseChartPoint"
              (onPointClick)="onPointClick($event)"
              (onInitialized)="onInitialized($event)">
        <dxo-chart-argument-axis>
            <dxo-chart-grid [opacity]="0.2"
                            [visible]="true"> </dxo-chart-grid>
            <dxo-chart-minor-grid [visible]="false"> </dxo-chart-minor-grid>
            <dxo-chart-label alignment="right"
                             format="monthAndYear"
                             overlappingBehavior="rotate"
                             [rotationAngle]="-45"> </dxo-chart-label>
        </dxo-chart-argument-axis>
        <dxi-chart-value-axis visualRangeUpdateMode="keep"
                              [maxValueMargin]="0.0001"
                              [tickInterval]="0.5"
                              [minorTickInterval]="0.1"
                              [visible]="true"
                              [visualRange]="[0, 2]">
            <dxo-chart-minor-tick [visible]="false"> </dxo-chart-minor-tick>
        </dxi-chart-value-axis>
        <dxi-chart-series type="scatter"
                          valueField="value"
                          argumentField="argument"
                          tagField="culturalIndex"> </dxi-chart-series>
        <dxo-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customiseTooltip"> </dxo-chart-tooltip>
        <dxo-chart-loading-indicator>
            <dxo-chart-font [size]="30"> </dxo-chart-font>
        </dxo-chart-loading-indicator>
        <dxo-chart-size [height]="responsiveService.currentBreakpoint.isMobileSize ? 300 : 600"> </dxo-chart-size>
        <dxo-chart-margin [left]="20"
                          [right]="20"> </dxo-chart-margin>
        <dxo-chart-legend [visible]="false"> </dxo-chart-legend>
    </dx-chart>
}

@if (!data.length) {
    <adapt-no-cultural-measurement label="Cultural Indexes"></adapt-no-cultural-measurement>
}
